import { RemoteData, FETCH_STATUSES } from "../base/types";
import { User } from "./user.types";
import {
  FETCH_USER_LOADING,
  FETCH_USER_SUCCESS,
  FETCH_USER_ERROR,
  UserActionTypes,
} from "./user.actions";

const defaulUserState: RemoteData<User> = {
  data: null,
  status: FETCH_STATUSES.NEVER,
};

const user = (
  state: RemoteData<any> = defaulUserState,
  action: UserActionTypes
): RemoteData<User> => {
  switch (action.type) {
    case FETCH_USER_LOADING:
      return {
        ...state,
        status: FETCH_STATUSES.LOADING,
      };
    case FETCH_USER_SUCCESS:
      return {
        status: FETCH_STATUSES.OK,
        data: action.payload,
      };
    case FETCH_USER_ERROR:
      return {
        status: FETCH_STATUSES.ERROR,
        data: null,
      };
    default:
      return state;
  }
};

export default user;
